import HundredBricksAPIError from '../../../HundredBricksAPIError';
class SendPurchaseTokenError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('SendPurchaseTokenError', ...args);
    }
}
export default SendPurchaseTokenError;
